export class AssociatedTransformer {

    static transform (obj) {
    
        let associated           = {}
        
        associated.id            = obj.id
        
        associated.parent_id     = obj.attributes.parent_id
        
        associated.child_id      = obj.attributes.child_id
        
        associated.code          = obj.attributes.code
        
        associated.archived_at   = obj.attributes.archived_at
        
        associated.deleted_at    = obj.attributes.deleted_at
        
        associated.contract_code = obj.attributes.contract_code
        
        // associated.name          = obj.attributes.name;

        return associated

    }

    static transformArray (array = []) {

        let data = []
        
        array.map(function (item) {
        
            data.push(AssociatedTransformer.transform(item))
        
        })
        
        return data
    }
}


// WEBPACK FOOTER //
// ./src/helpers/associated/associated.transformer.js